import React from 'react';
import * as S from './References.styles';
import { FacebookOutlined, LinkedinOutlined, TwitterOutlined } from '@ant-design/icons';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>
        Made by{' '}
        <a href="https://singletonsd.com" target="_blank" rel="noopener noreferrer">
          Singleton SD{' '}
        </a>
        in 2023 &copy;. Based on{' '}
        <a href="https://ant.design/" target="_blank" rel="noopener noreferrer">
          Ant-design.
        </a>
      </S.Text>
      <S.Icons>
        <a href="https://twitter.com/patoperpetua" target="_blank" rel="noopener noreferrer" title="twitter page">
          <TwitterOutlined />
        </a>
        <a href="https://www.facebook.com/patoperpetua" target="_blank" rel="noopener noreferrer" title="facebook page">
          <FacebookOutlined />
        </a>
        <a
          href="https://linkedin.com/in/patricio-perpetua"
          target="_blank"
          rel="noopener noreferrer"
          title="twitter page"
        >
          <LinkedinOutlined />
        </a>
      </S.Icons>
    </S.ReferencesWrapper>
  );
};
